import { PortableTextBlock } from "@portabletext/types";

const url = "/api/v1/gatherings";

export type GatheringPreview = {
  _id: string;
  dek: string;
  endedAt: string;
  featuredNum: number;
  featuredTag: string | null;
  gatheringLink?: string;
  heroImageAlt: string;
  heroImageSrc: string;
  rsvped?: boolean | null;
  slug: string;
  startedAt: string;
  title: string;
};

export type GatheringsIndexResponse = GatheringPreview[];

export const gatheringsIndexQuery = () => ({
  url: url,
  method: "GET",
});

// ! If this is modified, ensure to change _open_graph.html.erb
export type Gathering = {
  _id: string;
  body: PortableTextBlock[];
  dek: string;
  duration: string;
  endedAt: string;
  gatheringLink: string | null;
  gatheringPlatform: "gatheround" | "zoom";
  gatheringType: "virtual";
  heroImageAlt: string;
  heroImageSrc: string;
  materials: Material[] | null;
  metaDescription: string;
  metaTitle: string;
  speaker: Speaker | null;
  startedAt: string;
  slug: string;
  rsvped?: boolean | null;
  title: string;
};

export interface Material {
  _id: string;
  file?: string | null;
  link?: string | null;
  title: string;
  type: "docx" | "link" | "pdf";
}

interface Speaker {
  _id: string;
  alt: string | null;
  body: PortableTextBlock[];
  imgSrc: string | null;
  name: string;
}

export interface GatheringsShowParams {
  slug: string;
}

export const gatheringsShowQuery = ({ slug }: GatheringsShowParams) => ({
  url: `${url}/${slug}`,
  method: "GET",
});

export type GatheringsRsvpParams = {
  slug: string;
};

export const gatheringsRsvpQuery = ({ slug }: GatheringsRsvpParams) => ({
  url: `${url}/${slug}/rsvp`,
  method: "POST",
});

export type GatheringsDeclineParams = {
  slug: string;
  explanation?: string;
};

export const gatheringsDeclineQuery = ({
  slug,
  explanation,
}: GatheringsDeclineParams) => ({
  url: `${url}/${slug}/decline`,
  method: "PATCH",
  body: { explanation },
});
